import { useState, useMemo } from 'react';

export default function CohortMapfre() {
  const [vista, setVista] = useState('polizas');
  const [showPct, setShowPct] = useState(false);

  const years = [2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025];

  // Cohort POLIZAS: rows=cohort_year, cols=alive_year
  const polizasRaw = {
    2003: [10,7,7,5,4,3,3,3,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1],
    2004: [0,23,16,15,8,9,7,6,6,2,2,2,2,1,1,1,1,1,1,1,1,0,0],
    2005: [0,0,2,2,2,1,2,0,0,1,1,0,0,0,0,1,1,1,0,0,0,0,0],
    2006: [0,0,0,3,2,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    2007: [0,0,0,0,2,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0],
    2008: [0,0,0,0,0,2,2,2,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    2011: [0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    2012: [0,0,0,0,0,0,0,0,0,1,2,2,2,3,3,3,2,2,2,2,2,1,1],
    2013: [0,0,0,0,0,0,0,0,0,0,9,9,6,5,4,2,2,2,2,2,2,2,2],
    2014: [0,0,0,0,0,0,0,0,0,0,0,39,23,18,15,11,10,9,7,5,6,5,4],
    2015: [0,0,0,0,0,0,0,0,0,0,0,0,22,22,18,16,16,15,13,10,8,6,6],
    2016: [0,0,0,0,0,0,0,0,0,0,0,0,0,43,40,29,23,18,13,10,10,9,8],
    2017: [0,0,0,0,0,0,0,0,0,0,0,0,1,1,65,58,45,40,35,29,24,14,11],
    2018: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,98,85,66,62,50,38,32],
    2019: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,209,190,168,144,130,114,103],
    2020: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,274,239,200,170,144,118],
    2021: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,571,531,475,372,308],
    2022: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,815,748,638,513],
    2023: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,897,809,697],
    2024: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,707,619],
    2025: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,905],
  };

  // Cohort RECIBOS (Prima Neta €)
  const recibosRaw = {
    2003: [5824.13,4122.84,4488.33,2419.87,1652.93,1491.18,1575.57,1641.96,1798.28,1883.90,1878.87,360.15,364.75,378.45,387.45,407.61,426.20,426.19,452.18,485.98,535.37,618.43,652.09],
    2004: [0,19274.78,18283.05,20883.01,8233.13,10017.46,5243.87,4113.66,3989.53,2574.97,2292.62,2264.57,2375.66,1058.99,1080.17,1153.08,1228.03,1305.40,1305.40,1400.04,1526.04,0,0],
    2005: [0,0,2350.86,3009.58,1924.77,2217.42,2413.12,0,0,0.01,0.03,0,0,0,0,150,150,10,0,0,0,0,0],
    2006: [0,0,0,2575.05,1659.46,276.92,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    2007: [0,0,0,0,1327.59,497.67,524.63,550.33,570.12,581.50,597.82,621.73,637.28,654.81,0,0,0,0,0,0,0,0,0],
    2008: [0,0,0,0,0,2274.98,2365.92,2420.39,2468.80,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    2011: [0,0,0,0,0,0,0,0,1565.61,1357.44,1452.20,1464.12,1603.85,1601.88,1694.53,1788.81,1928.86,2037.38,2139.29,2289.07,2480.18,3074.15,3360.32],
    2012: [0,0,0,0,0,0,0,0,0,3457.66,3052.16,3443.14,3543.04,3300.87,3862.66,3527.14,4071.82,3645.40,4824.99,4973.69,4200.24,5526.70,4034.58],
    2013: [0,0,0,0,0,0,0,0,0,0,3381.32,4017.71,2408.79,1726.80,1304.17,861.15,903.45,956.95,970.59,993.33,1064.44,1156.36,1259.65],
    2014: [0,0,0,0,0,0,0,0,0,0,0,53916.25,11101.97,11024.76,9774.81,8933.85,9256.56,9179.72,5282.56,5178.17,5826.11,5167.03,4530.72],
    2015: [0,0,0,0,0,0,0,0,0,0,0,0,26829.51,29915.23,26020.49,25521.69,28104.66,26798.91,20627.51,18388.96,15995.35,14537.25,16329.70],
    2016: [0,0,0,0,0,0,0,0,0,0,0,0,0,29572.27,35132.56,29993.20,22504.63,17394.96,14866.79,12589.40,14140.24,14540.73,15794.87],
    2017: [0,0,0,0,0,0,0,0,0,0,0,0,171.46,623.47,26675.58,32063.09,23013.52,16751.97,13998.05,12656.54,8677.55,6053.89,4985.60],
    2018: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,85850.43,107558.85,102582.30,73000.23,71492.45,55744.80,45670.98,39190.99],
    2019: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,209249.41,208432.53,197949.55,159833.81,176545.89,165332.23,165657.17],
    2020: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,559.37,224523.43,242461.43,210054.32,187380.98,175248.26,172937.81],
    2021: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,459833.30,540239.45,517617.26,456610.25,425682.13],
    2022: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,738959.70,855834.96,792224.69,731321.10],
    2023: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,86.38,842273.22,982165.73,928783.54],
    2024: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,373.98,922412.42,1108530.50],
    2025: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1196521.02],
  };

  const cohortYears = Object.keys(polizasRaw).map(Number).sort((a,b) => a - b);

  // Get the initial value for each cohort (first non-zero)
  const getInitialValue = (row) => {
    for (let i = 0; i < row.length; i++) {
      if (row[i] > 0) return row[i];
    }
    return 0;
  };

  // Compute retention percentages
  const computePct = (raw) => {
    const result = {};
    for (const [cy, row] of Object.entries(raw)) {
      const init = getInitialValue(row);
      result[cy] = row.map(v => init > 0 && v > 0 ? ((v / init) * 100) : 0);
    }
    return result;
  };

  const polizasPct = useMemo(() => computePct(polizasRaw), []);
  const recibosPct = useMemo(() => computePct(recibosRaw), []);

  const currentRaw = vista === 'polizas' ? polizasRaw : recibosRaw;
  const currentPct = vista === 'polizas' ? polizasPct : recibosPct;
  const data = showPct ? currentPct : currentRaw;

  // Heatmap color based on retention %
  const getColor = (cohortYear, yearIdx, value) => {
    if (value === 0) return 'transparent';
    const row = currentRaw[cohortYear];
    const init = getInitialValue(row);
    if (init === 0) return 'transparent';
    const pct = (value / init) * 100;
    const retPct = showPct ? value : pct;

    // For the initial year (100%), use a strong blue
    if (retPct >= 95) return 'rgba(30, 64, 175, 0.85)';
    if (retPct >= 80) return 'rgba(37, 99, 235, 0.75)';
    if (retPct >= 60) return 'rgba(59, 130, 246, 0.6)';
    if (retPct >= 40) return 'rgba(96, 165, 250, 0.45)';
    if (retPct >= 20) return 'rgba(147, 197, 253, 0.35)';
    if (retPct >= 10) return 'rgba(191, 219, 254, 0.3)';
    return 'rgba(219, 234, 254, 0.2)';
  };

  const getTextColor = (cohortYear, value) => {
    if (value === 0) return 'transparent';
    const row = currentRaw[cohortYear];
    const init = getInitialValue(row);
    if (init === 0) return '#64748b';
    const pct = showPct ? value : (value / init) * 100;
    return pct >= 60 ? '#ffffff' : '#1e293b';
  };

  const formatVal = (v) => {
    if (v === 0) return '';
    if (showPct) return v.toFixed(0) + '%';
    if (vista === 'recibos') {
      if (v >= 1000) return (v / 1000).toFixed(0) + 'k';
      return v.toFixed(0);
    }
    return v.toLocaleString('es-ES');
  };

  // Summary stats
  const totalPolizasInicio = cohortYears.reduce((sum, cy) => sum + getInitialValue(polizasRaw[cy]), 0);
  const totalPolizas2025 = cohortYears.reduce((sum, cy) => sum + polizasRaw[cy][22], 0);
  const retGlobal = totalPolizasInicio > 0 ? ((totalPolizas2025 / totalPolizasInicio) * 100) : 0;

  const bigCohorts = cohortYears.filter(cy => getInitialValue(polizasRaw[cy]) >= 50);
  const avgRetBig = bigCohorts.length > 0
    ? bigCohorts.reduce((sum, cy) => {
        const init = getInitialValue(polizasRaw[cy]);
        const current = polizasRaw[cy][22];
        return sum + (current / init * 100);
      }, 0) / bigCohorts.length
    : 0;

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
      fontFamily: "'Söhne', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      color: '#e2e8f0',
      padding: '32px 24px',
    }}>
      <div style={{ maxWidth: 1400, margin: '0 auto' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #dc2626, #ef4444)',
            padding: '6px 20px',
            borderRadius: 6,
            marginBottom: 16,
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 2,
            textTransform: 'uppercase',
          }}>MAPFRE</div>
          <h1 style={{
            fontSize: 36,
            fontWeight: 800,
            margin: 0,
            background: 'linear-gradient(135deg, #f8fafc, #94a3b8)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: -1,
          }}>Estudio de Cohortes</h1>
          <p style={{ color: '#64748b', fontSize: 15, marginTop: 8 }}>
            Análisis de retención 2003 – 2025
          </p>
        </div>

        {/* KPIs */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 32 }}>
          {[
            { label: 'Cohortes activas', value: cohortYears.length, accent: '#3b82f6' },
            { label: 'Pólizas inicio (sum)', value: totalPolizasInicio.toLocaleString('es-ES'), accent: '#8b5cf6' },
            { label: 'Pólizas vivas 2025', value: totalPolizas2025.toLocaleString('es-ES'), accent: '#10b981' },
            { label: 'Ret. media (cohortes >50)', value: avgRetBig.toFixed(1) + '%', accent: '#f59e0b' },
          ].map((kpi, i) => (
            <div key={i} style={{
              background: 'rgba(30, 41, 59, 0.8)',
              border: '1px solid rgba(148, 163, 184, 0.1)',
              borderRadius: 12,
              padding: '20px 16px',
              borderLeft: `3px solid ${kpi.accent}`,
            }}>
              <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 1 }}>{kpi.label}</div>
              <div style={{ fontSize: 24, fontWeight: 700, color: '#f8fafc' }}>{kpi.value}</div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 24, flexWrap: 'wrap' }}>
          {[
            { id: 'polizas', label: '📋 Pólizas (Nº)' },
            { id: 'recibos', label: '💰 Prima Neta (€)' },
          ].map(opt => (
            <button key={opt.id} onClick={() => setVista(opt.id)} style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: vista === opt.id ? '1px solid #3b82f6' : '1px solid rgba(148,163,184,0.2)',
              background: vista === opt.id ? 'rgba(59,130,246,0.15)' : 'rgba(30,41,59,0.6)',
              color: vista === opt.id ? '#93c5fd' : '#94a3b8',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 14,
              transition: 'all 0.2s',
            }}>{opt.label}</button>
          ))}
          <button onClick={() => setShowPct(!showPct)} style={{
            padding: '10px 20px',
            borderRadius: 8,
            border: showPct ? '1px solid #f59e0b' : '1px solid rgba(148,163,184,0.2)',
            background: showPct ? 'rgba(245,158,11,0.15)' : 'rgba(30,41,59,0.6)',
            color: showPct ? '#fcd34d' : '#94a3b8',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: 14,
            transition: 'all 0.2s',
          }}>{showPct ? '% Retención' : '# Absolutos'}</button>
        </div>

        {/* Cohort Table */}
        <div style={{
          background: 'rgba(15, 23, 42, 0.9)',
          border: '1px solid rgba(148, 163, 184, 0.1)',
          borderRadius: 16,
          overflow: 'hidden',
          marginBottom: 32,
        }}>
          <div style={{ padding: '20px 24px', borderBottom: '1px solid rgba(148,163,184,0.1)' }}>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#f8fafc' }}>
              {vista === 'polizas' ? 'Cohorte por Nº de Pólizas' : 'Cohorte por Prima Neta (€)'}
              {showPct && ' — % Retención'}
            </h2>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>
              Filas: año de alta (POL_PrimerEfecto) · Columnas: año con recibo activo (sit. 1,5,6)
            </p>
          </div>
          <div style={{ overflowX: 'auto', padding: '0 0 16px' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 1200 }}>
              <thead>
                <tr>
                  <th style={{
                    position: 'sticky', left: 0, zIndex: 2,
                    background: '#0f172a',
                    padding: '10px 12px',
                    fontSize: 11,
                    fontWeight: 700,
                    color: '#94a3b8',
                    textAlign: 'left',
                    borderBottom: '2px solid rgba(148,163,184,0.15)',
                    letterSpacing: 1,
                    textTransform: 'uppercase',
                  }}>Cohorte</th>
                  <th style={{
                    position: 'sticky', left: 72, zIndex: 2,
                    background: '#0f172a',
                    padding: '10px 8px',
                    fontSize: 11,
                    fontWeight: 700,
                    color: '#94a3b8',
                    textAlign: 'center',
                    borderBottom: '2px solid rgba(148,163,184,0.15)',
                    letterSpacing: 1,
                  }}>Inicio</th>
                  {years.map(y => (
                    <th key={y} style={{
                      padding: '10px 4px',
                      fontSize: 10,
                      fontWeight: 600,
                      color: '#64748b',
                      textAlign: 'center',
                      borderBottom: '2px solid rgba(148,163,184,0.15)',
                      minWidth: 44,
                    }}>{y}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {cohortYears.map(cy => {
                  const row = data[cy];
                  const rawRow = currentRaw[cy];
                  const init = getInitialValue(rawRow);
                  return (
                    <tr key={cy} style={{ borderBottom: '1px solid rgba(148,163,184,0.05)' }}>
                      <td style={{
                        position: 'sticky', left: 0, zIndex: 1,
                        background: '#0f172a',
                        padding: '8px 12px',
                        fontWeight: 700,
                        fontSize: 13,
                        color: '#e2e8f0',
                      }}>{cy}</td>
                      <td style={{
                        position: 'sticky', left: 72, zIndex: 1,
                        background: '#0f172a',
                        padding: '8px',
                        textAlign: 'center',
                        fontWeight: 700,
                        fontSize: 12,
                        color: '#93c5fd',
                      }}>
                        {vista === 'recibos'
                          ? (init >= 1000 ? (init/1000).toFixed(0) + 'k' : init.toFixed(0))
                          : init.toLocaleString('es-ES')
                        }
                      </td>
                      {row.map((v, idx) => {
                        const rawV = rawRow[idx];
                        return (
                          <td key={idx} style={{
                            padding: '6px 3px',
                            textAlign: 'center',
                            fontSize: 10,
                            fontWeight: rawV > 0 ? 600 : 400,
                            color: getTextColor(cy, rawV),
                            background: getColor(cy, idx, rawV),
                            transition: 'all 0.15s',
                            borderRadius: 2,
                          }}>
                            {formatVal(showPct ? (init > 0 && rawV > 0 ? (rawV/init*100) : 0) : rawV)}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* Legend */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 16,
          marginBottom: 32,
          flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: 12, color: '#64748b' }}>Retención:</span>
          {[
            { label: '95%+', color: 'rgba(30, 64, 175, 0.85)' },
            { label: '80%+', color: 'rgba(37, 99, 235, 0.75)' },
            { label: '60%+', color: 'rgba(59, 130, 246, 0.6)' },
            { label: '40%+', color: 'rgba(96, 165, 250, 0.45)' },
            { label: '20%+', color: 'rgba(147, 197, 253, 0.35)' },
            { label: '<20%', color: 'rgba(219, 234, 254, 0.2)' },
          ].map((l, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ width: 14, height: 14, borderRadius: 3, background: l.color }} />
              <span style={{ fontSize: 11, color: '#94a3b8' }}>{l.label}</span>
            </div>
          ))}
        </div>

        {/* Retention Summary by Cohort */}
        <div style={{
          background: 'rgba(15, 23, 42, 0.9)',
          border: '1px solid rgba(148, 163, 184, 0.1)',
          borderRadius: 16,
          overflow: 'hidden',
          marginBottom: 24,
        }}>
          <div style={{ padding: '20px 24px', borderBottom: '1px solid rgba(148,163,184,0.1)' }}>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#f8fafc' }}>
              Resumen de Retención por Cohorte (Pólizas)
            </h2>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
              <thead>
                <tr>
                  {['Cohorte','Inicio','1 año','2 años','3 años','5 años','Actual (2025)','Ret. actual'].map(h => (
                    <th key={h} style={{
                      padding: '12px 16px',
                      fontSize: 11,
                      fontWeight: 700,
                      color: '#94a3b8',
                      textAlign: h === 'Cohorte' ? 'left' : 'right',
                      borderBottom: '2px solid rgba(148,163,184,0.15)',
                      letterSpacing: 0.5,
                      textTransform: 'uppercase',
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {cohortYears.filter(cy => getInitialValue(polizasRaw[cy]) >= 10).map(cy => {
                  const row = polizasRaw[cy];
                  const init = getInitialValue(row);
                  const cyIdx = years.indexOf(cy);
                  const y1 = cyIdx + 1 < 23 ? row[cyIdx + 1] : null;
                  const y2 = cyIdx + 2 < 23 ? row[cyIdx + 2] : null;
                  const y3 = cyIdx + 3 < 23 ? row[cyIdx + 3] : null;
                  const y5 = cyIdx + 5 < 23 ? row[cyIdx + 5] : null;
                  const actual = row[22]; // 2025
                  const retActual = init > 0 ? (actual / init * 100) : 0;

                  const fmtPct = (v) => v !== null && init > 0 ? (v / init * 100).toFixed(0) + '%' : '—';
                  const barWidth = Math.min(retActual, 100);

                  return (
                    <tr key={cy} style={{ borderBottom: '1px solid rgba(148,163,184,0.05)' }}>
                      <td style={{ padding: '10px 16px', fontWeight: 700, fontSize: 14, color: '#e2e8f0' }}>{cy}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', fontSize: 13, color: '#93c5fd', fontWeight: 600 }}>{init}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', fontSize: 13, color: '#cbd5e1' }}>{fmtPct(y1)}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', fontSize: 13, color: '#cbd5e1' }}>{fmtPct(y2)}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', fontSize: 13, color: '#cbd5e1' }}>{fmtPct(y3)}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', fontSize: 13, color: '#cbd5e1' }}>{fmtPct(y5)}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', fontSize: 13, color: '#f8fafc', fontWeight: 600 }}>{actual}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
                          <div style={{ width: 60, height: 6, background: 'rgba(148,163,184,0.1)', borderRadius: 3, overflow: 'hidden' }}>
                            <div style={{
                              width: barWidth + '%',
                              height: '100%',
                              background: retActual > 50 ? '#10b981' : retActual > 20 ? '#f59e0b' : '#ef4444',
                              borderRadius: 3,
                              transition: 'width 0.3s',
                            }} />
                          </div>
                          <span style={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: retActual > 50 ? '#10b981' : retActual > 20 ? '#f59e0b' : '#ef4444',
                          }}>{retActual.toFixed(0)}%</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <p style={{ textAlign: 'center', fontSize: 12, color: '#475569', marginTop: 20 }}>
          Criterio: Póliza viva = al menos 1 recibo en situación activa (1, 5 o 6) con efecto en el año · CIA_Id = 100015
        </p>
      </div>
    </div>
  );
}
